import type { TMDBItem, MediaPreview, MediaType } from '../types';

/**
 * Transforms raw TMDB API data into clean, unified MediaPreview format
 * @param raw - The raw item from TMDB
 * @param fallbackType - If the API doesn't provide media_type (like in 'discover') then use the currently active tab.
 */
export const toPreview = (raw: TMDBItem, fallbackType?: MediaType): MediaPreview => {
  const type = raw.media_type || fallbackType;

  if (!type) {
    throw new Error("Normalization failed: No media_type provided or inferred.");
  }

  return {
    id: raw.id,
    media_type: type as MediaType,
    displayTitle: type === 'movie' 
        ? (raw as any).title 
        : (raw as any).name,
    displayDate: type === 'movie' 
        ? (raw as any).release_date 
        : (raw as any).first_air_date,
    poster_path: raw.poster_path,
    vote_average: raw.vote_average,
  };
};